import { render, staticRenderFns } from "./StatusUpdateKeywordPopup.vue?vue&type=template&id=57732492"
import script from "./StatusUpdateKeywordPopup.vue?vue&type=script&lang=js"
export * from "./StatusUpdateKeywordPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports